import { apiV2 } from 'src/services/storage/project/http'
import * as types from './types'

export * from './types'

export const getSmartList = ({
  schemeName,
  ...params
}: types.IGetSmartListParams) =>
  apiV2.get<types.IGetSmartListData>(`/scheme/${schemeName}/smart_list`, {
    params,
  })

export const getSmartListItem = (params: types.IGetSmartListItemParams) =>
  apiV2.get<types.IGetSmartListItemData>(
    `/scheme/${params.schemeName}/smart_list/${params.uniqId}`
  )
export const getSmartListItemDefault = (
  params: types.IGetSmartListItemDefaultParams
) =>
  apiV2.get<types.IGetSmartListItemData>(
    `/scheme/${params.schemeName}/smart_list/default`
  )

export const putSmartList = (params: types.IPutSmartListParams) =>
  apiV2.put<types.IGetSmartListData>(
    `/scheme/${params.schemeName}/smart_list/${params.uniqId}`,
    params.data
  )

export const putSmartListDefault = (params: types.IPutSmartListDefaultParams) =>
  apiV2.put<types.IGetSmartListData>(
    `/scheme/${params.schemeName}/smart_list/default`,
    {
      type: 'default',
      title: 'default',
      ...params.data,
    }
  )

export const postManualListObjectsAssign = (
  params: types.IPostManualListObjectsAssignParams
) =>
  apiV2.post<types.IGetSmartListData>(
    `/scheme/${params.schemeName}/smart_list/${params.uniqId}/objects/assign`,
    {
      objectsUniqIds: params.objectsUniqIds,
    }
  )

export const postManualListObjectsRemove = (
  params: types.IPostManualListObjectsAssignParams
) =>
  apiV2.post<types.IGetSmartListData>(
    `/scheme/${params.schemeName}/smart_list/${params.uniqId}/objects/assign`,
    {
      objectsUniqIds: params.objectsUniqIds,
    }
  )

export const postSmartList = (params: types.IPostSmartListParams) =>
  apiV2.post<types.IGetSmartListData>(
    `/scheme/${params.schemeName}/smart_list`,
    params.data
  )
export const postSmartListDefault = (
  params: types.IPutSmartListDefaultParams
) =>
  apiV2.post<types.IGetSmartListData>(
    `/scheme/${params.schemeName}/smart_list`,
    {
      type: 'default',
      title: 'default',
      ...params.data,
    }
  )
export const deleteSmartList = ({
  schemeName,
  uniqId,
}: types.IDeleteSmartListParams) =>
  apiV2.delete<types.IGetSmartListData>(
    `/scheme/${schemeName}/smart_list/${uniqId}`
  )

// USERS

export const addSmartListUsers = ({
  schemeName,
  uniqId,
  usersIds,
}: types.IAddSmartListUsersParams) =>
  apiV2.post<types.ISmartList>(
    `/scheme/${schemeName}/smart_list/${uniqId}/users/add`,
    {
      usersIds,
    }
  )
export const removeSmartListUsers = ({
  schemeName,
  uniqId,
  usersIds,
}: types.IRemoveSmartListUsersParams) =>
  apiV2.post<types.ISmartList>(
    `/scheme/${schemeName}/smart_list/${uniqId}/users/remove`,
    {
      usersIds,
    }
  )

// PERMISSIONS GROUPS

export const addSmartListGroups = ({
  schemeName,
  uniqId,
  groupsIds,
}: types.IAddSmartListGroupsParams) =>
  apiV2.post(`/scheme/${schemeName}/smart_list/${uniqId}/groups/add`, {
    groupsIds,
  })

export const removeSmartListGroups = ({
  schemeName,
  uniqId,
  groupsIds,
}: types.IRemoveSmartListGroupsParams) =>
  apiV2.post(`/scheme/${schemeName}/smart_list/${uniqId}/groups/remove`, {
    groupsIds,
  })

export const getSmartListPermissions = ({
  schemeName,
  uniqId,
}: types.IGetSmartListPermissionsParams) =>
  apiV2.get<types.IGetSmartListPermissionsData>(
    `/scheme/${schemeName}/smart_list/${uniqId}/permissions`
  )

export const postSmartListPermissions = ({
  schemeName,
  uniqId,
  ...data
}: types.IPostSmartListPermissionsParams) =>
  apiV2.post<types.IPostSmartListPermissionsData>(
    `/scheme/${schemeName}/smart_list/${uniqId}/permissions`,
    data
  )

export const SmartListPermissionsOptions = [
  { label: 'Update smart list', value: types.ESmartListPermissions.itemUpdate },
  { label: 'View objects', value: types.ESmartListPermissions.objectsView },
  { label: 'Edit objects', value: types.ESmartListPermissions.objectsEdit },
] as const

export const postSmartListPermissionsUsersAdd = ({
  schemeName,
  uniqId,
  ...data
}: types.IPostSmartListPermissionsUsersAddParams) =>
  apiV2.post(
    `/scheme/${schemeName}/smart_list/${uniqId}/permissions/users/add`,
    data
  )

export const postSmartListPermissionsUsersRemove = ({
  schemeName,
  uniqId,
  ...data
}: types.IPostSmartListPermissionsUsersRemoveParams) =>
  apiV2.post(
    `/scheme/${schemeName}/smart_list/${uniqId}/permissions/users/remove`,
    data
  )

export const postSmartListPermissionsGroupsAdd = ({
  schemeName,
  uniqId,
  ...data
}: types.IPostSmartListPermissionsGroupsAddParams) =>
  apiV2.post(
    `/scheme/${schemeName}/smart_list/${uniqId}/permissions/groups/add`,
    data
  )

export const postSmartListPermissionsGroupsRemove = ({
  schemeName,
  uniqId,
  ...data
}: types.IPostSmartListPermissionsGroupsRemoveParams) =>
  apiV2.post(
    `/scheme/${schemeName}/smart_list/${uniqId}/permissions/groups/remove`,
    data
  )

export const getSmartListUserOptions = ({
  schemeName,
  uniqId,
}: types.IGetSmartListUserOptionsParams) =>
  apiV2.get<types.IGetSmartListUserOptionsData>(
    `/scheme/${schemeName}/smart_list/${uniqId}/user-options`
  )

export const patchSmartListUserOptions = ({
  schemeName,
  uniqId,
  ...data
}: types.IPatchSmartListUserOptionsParams) =>
  apiV2.post<types.IPatchSmartListUserOptionsData>(
    `/scheme/${schemeName}/smart_list/${uniqId}/user-options`,
    data
  )

export const getSmartListDefaultUserOptions = ({
  schemeName,
}: types.IGetSmartListDefaultUserOptionsParams) =>
  apiV2.get<types.IGetSmartListDefaultUserOptionsData>(
    `/scheme/${schemeName}/smart_list/default/user-options`
  )

export const patchSmartListDefaultUserOptions = ({
  schemeName,
  ...data
}: types.IPatchSmartListDefaultUserOptionsParams) =>
  apiV2.patch<types.IPatchSmartListDefaultUserOptionsData>(
    `/scheme/${schemeName}/smart_list/default/user-options`,
    data
  )
